/* eslint-disable @typescript-eslint/no-explicit-any */
import { MenuItem, TextField } from "@mui/material";

export enum ReportTypes {
  DairyCarbon = "Dairy Carbon",
  Dairy = "Dairy",
  DairyV2 = "Dairy V2",
  BeefCarbon = "Beef Carbon",
}

interface IReportTypeSelectProps {
  label?: string;
  placeholder?: string;
  value?: ReportTypes;
  onChange: (newVal?: ReportTypes) => void;
  error?: boolean;
  helperText?: string;
}
export default function ReportTypeSelect(props: IReportTypeSelectProps) {
  const { value, onChange, helperText, error } = props;
  return (
    <TextField
      label={props.label}
      select
      fullWidth
      placeholder="Select Report Type"
      helperText={helperText}
      error={error}
      value={value || ""}
      size="small"
      onChange={(e) => {
        onChange(e.target.value as unknown as ReportTypes);
      }}
    >
      {Object.values(ReportTypes).map((type, i) => (
        <MenuItem key={`report-type-${i}`} value={type as ReportTypes}>
          {type}
        </MenuItem>
      ))}
    </TextField>
  );
}
